<template>
  <div>
      <NewClient v-if="client_id" mode="edit" :client_id="client_id"></NewClient>
  </div>
</template>

<script>
  import NewClient from './NewClient'

  export default {
    name: "EditClient",
    components: {NewClient},
    data() {
      return {
        client_id: "",
      }
    },
    created() {
      this.client_id = this.$route.params.id;
    },
  }
</script>

<style scoped>

</style>